import React, { useEffect, useState } from 'react'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
const TextArea = (props: IElementProps) => {
  const [savedExternalData, setSavedExternalData] = useState<IExternalDataItem>()
  const { externalData, formReadOnly } = props
  useEffect(() => {
    if (
      props.visible &&
      !formReadOnly &&
      (externalData?.timeStamp || 0) > (savedExternalData?.timeStamp || 0) &&
      externalData &&
      Object.keys(externalData.data).length
    ) {
      const externalValue = externalData.data[Object.keys(externalData.data)[0]]

      const e = {
        target: {
          value: externalValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      setTimeout(() => {
        props.handleChange(props.name, e)
      }, props.index * 10)

      setSavedExternalData(externalData)
    }
  }, [props.externalData, formReadOnly, props.visible])

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <textarea
            readOnly={props.formReadOnly || props.disabledInput}
            // name={props.name}
            name="fieldname"
            key={props.name}
            autoComplete="none"
            onChange={(e) => props.handleChange(props.name, e)}
            className="required-highlight"
          >
            {props.value}
          </textarea>
        </div>
      )}
    </>
  )
}
export default TextArea
